module.exports = __webpack_public_path__ + "img/test3.21e765ff.png";